import React, { useMemo } from "react";
import GaugeChart from "react-gauge-chart";

const Gauge = ({ data, additionalData, className, style }) => {
  const {
    arcsLength,
    colors,
    percent,
    averageLabel,
    label,
    nrOfLevels,
    arcPadding,
    animate,
    cornerRadius,
    hideText,
    maxLabel,
    minLabel,
  } = data;

  const percentage = useMemo(() => {
    console.log("test label", label, percent);
    if (label === "Occupancy Density") {
      if (percent >= 1 && percent <= 2) {
        return 0.8;
      } else if (percent >= 3 && percent <= 4) {
        return 0.5;
      } else {
        return 0.2;
      }
    }
    // Logic for Occupancy Utilization and Space Utilization
    else if (
      label === "Occupancy Utilization" ||
      label === "Space Utilization"
    ) {
      if (percent >= 0 && percent <= 19) return 0.2;
      if (percent > 19 && percent < 50) return 0.5;
      if (percent >= 50 && percent <= 100) return 0.8;
      return 0.2;
    }

    // if (percent >= 0 && percent <= 30) return 0.2;
    // if (percent > 30 && percent < 50) return 0.5;
    // if (percent >= 50 && percent <= 100) return 0.8;

    return percent;
  }, [percent, label]);
  return (
    <>
      {label !== "Space Utilization" ? (
        <GaugeChart
          id="gauge-chart4"
          arcsLength={arcsLength}
          colors={colors}
          nrOfLevels={nrOfLevels ? nrOfLevels : arcsLength.arcsLength}
          arcPadding={arcPadding ? arcPadding : 0.1}
          animate={animate ? animate : false}
          cornerRadius={cornerRadius ? cornerRadius : 4}
          percent={percentage}
          hideText={hideText ? hideText : true}
          style={style}
          className={className}
        />
      ) : null}

      <p className="container d-flex flex-column gap-2 dashboard-health-title m-0">
        <span>
          {label !== "Occupancy Utilization" &&
            label !== "Space Utilization" &&
            averageLabel}
        </span>
        {label === "Occupancy Utilization" && (
          <div
            className="d-flex justify-content-center align-items-center card-value gap-2"
            style={{ flexWrap: "nowrap", color: "white" }}
          >
            <span className="text-nowrap" style={{ fontSize: "14px" }}>
              🔴0-19
            </span>
            <span className="text-nowrap" style={{ fontSize: "14px" }}>
              🟡20-49
            </span>
            <span className="text-nowrap" style={{ fontSize: "14px" }}>
              🟢50-100
            </span>
          </div>
        )}
        {label === "Space Utilization" && (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div 
                className="m-0 w-100 h-10"
            >
              <img
                src="/images/icons/no-of-people.png"
                alt=""
                width={40}
              />
            </div>

            <div
              className="d-flex justify-content-center align-items-center card-value gap-4"
              style={{ flexWrap: "nowrap", color: "white" }}
            >
              <div className="d-flex flex-column" style={{ fontSize: "14px" }}>
                <span className="text-nowrap">
                Min: 
                 {' '} {additionalData?.minAvg && additionalData?.minAvg}
                </span>
              </div>
              <div className="d-flex flex-column" style={{ fontSize: "14px" }}>
                <span className="text-nowrap">
                Max:{' '}
                   {additionalData?.maxAvg && additionalData?.maxAvg}
                </span>
              </div>
            </div>
          </div>
        )}
        <h6 className="dashboard-health-lead text-nowrap">
          {label === "Space Utilization"
            ? "Occupancy By Location(s)"
            : label === "Occupancy Utilization"
            ? "Space Utilization"
            : label}
        </h6>
      </p>
      {maxLabel && (
        <div className="d-flex justify-content-between dashboard-health-lead">
          <p className="m-0 p-0">Max:</p>
          <p className="m-0 p-0">{maxLabel}</p>
        </div>
      )}
      {minLabel && (
        <div className="d-flex justify-content-between dashboard-health-lead">
          <p className="m-0 p-0">Min:</p>
          <p className="m-0 p-0">{minLabel}</p>
        </div>
      )}
    </>
  );
};

export default Gauge;
